import IconPicture from '@/icons/Picture.svg';
import { ArticleActionWithRelations } from '@/models/request';
import { useDatabaseTranslation } from '@/services/i18n';
import { createBEMClasses } from '@/utils/classname';

import './ActionCard/ActionSpareParts.css';

const { element } = createBEMClasses('action-spare-parts');

export const SparePartTypeImage = ({
  sparePartType,
}: {
  sparePartType: ArticleActionWithRelations['spareParts'][number]['sparePartType'];
}) => {
  const { _db } = useDatabaseTranslation();
  const sparePartName = _db(sparePartType.name);

  return sparePartType.imageUrl ? (
    <img alt={sparePartName} src={sparePartType.imageUrl} className={element('img')} />
  ) : (
    <div className={element('img-placeholder')}>
      <IconPicture className="text-disabled" />
    </div>
  );
};
